import React, { useState } from 'react';
import { LoadingOutlined, MoreOutlined } from '@ant-design/icons';
import { Menu, Space, message } from 'antd';
import { downloadDocumentLibraryFolder } from '@gtintel/platform-api';
import { zipAndDownloadDocumentLibraryFolder } from '../../downloadFile';
import DeleteModal from '../DeleteModal';
import MoveModal from '../MoveModal';
import { DownloadContainer, DropdownItem, SpacerMenu } from './styles';
const openInNewTab = url => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
export default function DropdownMenu({
  file,
  projectId,
  refreshFileList,
  disableMove
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [moveModal, setMoveModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const downloadZippedFolder = (folderInfo, projectId) => {
    let folder = folderInfo;
    if (folderInfo.slice(-1) === '/') {
      folder = folderInfo.slice(0, -1);
    }
    setIsLoading(true);
    message.success('Your download is being prepared. This might take a while.');
    const responseHandler = zipAndDownloadDocumentLibraryFolder.bind(this, `GTI-project-${projectId}-${folder}`);
    downloadDocumentLibraryFolder({
      folder,
      projectId
    }).then(responseHandler).catch(error => {
      console.error(error);
      message.error('Something went wrong while preparing the download. Please contact an admin!');
    }).finally(() => setIsLoading(false));
  };
  const isFile = file.extension !== 'folder';
  const menu = <Menu>
      {isFile ? <SpacerMenu key="1" onClick={() => openInNewTab(file.link)} data-testid="doc-drop-menu-download">
          Download Document
        </SpacerMenu> : <SpacerMenu key="1" onClick={() => downloadZippedFolder(file.path, projectId)} data-testid="doc-drop-menu-download">
          Download Folder
        </SpacerMenu>}
      {!disableMove && <SpacerMenu key="2" onClick={() => setMoveModal(true)}>
          Move {isFile ? 'Document' : 'Folder'}
        </SpacerMenu>}
      <SpacerMenu key="3" onClick={() => setRemoveModal(true)}>
        Delete {isFile ? 'Document' : 'Folder'}
      </SpacerMenu>
    </Menu>;
  return <Space wrap>
      {isLoading ? <DownloadContainer>
          <LoadingOutlined />
        </DownloadContainer> : <DropdownItem placement="topLeft" icon={<MoreOutlined />} overlay={menu} data-testid="doc-drop-menu" />}
      <MoveModal file={file} isVisible={moveModal} projectId={projectId} refreshFileList={refreshFileList} setIsVisible={setMoveModal} />
      <DeleteModal documentId={file.id} isFile={isFile} isVisible={removeModal} path={file.path} projectId={projectId} refreshFileList={refreshFileList} setIsVisible={setRemoveModal} />
    </Space>;
}